// extracted by mini-css-extract-plugin
export default {"projectContainer":"Projects_projectContainer__P4uyw","headerShowHide":"Projects_headerShowHide__olUMX","fadeInUp":"Projects_fadeInUp__njHaZ"};